import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Button,
  Badge as ChakraBadge,
  Checkbox,
  Flex,
  HStack,
  Input,
  Text, useMediaQuery,
  Wrap,
  WrapItem,
  Icon
} from "@chakra-ui/react"

import { Link, Script } from "gatsby"
import slugger from "github-slugger"
import moment from "moment"
import React, { useEffect, useState } from "react"
import { FaChevronLeft, FaStar, FaStarHalfAlt } from "react-icons/fa"
import { MdArrowBack, MdArrowForward, MdArrowForwardIos } from "react-icons/md"
import styled from "styled-components"
import 'swiper/css/bundle'
import { Navigation } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import { customerList, MEDIA_PROCESSING_CUSTOMERS } from "../../data/customers"
import { DEVELOPER_COUNT, PAID_CUSTOMERS, TOTAL_COUNTRIES } from "../../data/stats"
import { globalStyleVariables } from "../../styles/variables"
// import { SDKList } from "../sdkList"
import { sdkList } from "../../data/sdkList"
import { MarkdownWrapper } from "./style"

const Pattern = styled.div`
  display: none;
  @media (${globalStyleVariables.MOBILE_MEDIA_QUERY}) {
    display: none;
  }
`

export const Table = styled.table`
    margin-left: 0;
    margin-right: 0;
    margin-top: 0;
    padding-bottom: 0;
    padding-left: 0;
    padding-right: 0;
    padding-top: 0;
    margin-bottom: 20px; 
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
    box-shadow: ${globalStyleVariables.CARD_SHADOW};

    tr {
      // border-top: 1px solid ${globalStyleVariables.MEDIUM_BG};
      background-color: white;
      margin: 0;
      padding: 0;

      &:hover {
        background: ${globalStyleVariables.MEDIUM_BG};
      }

      &:nth-child(2n) {
        // background-color: #f8f8f8;
      }

      th {
        font-weight: bold;
        // border: 1px solid #cccccc;
        text-align: left;
        margin: 0;
        padding: 15px 30px; 
        // white-space: nowrap;
        background: ${globalStyleVariables.LOGO_BLUE};
        color: white;

        @media (${globalStyleVariables.MOBILE_MEDIA_QUERY}) {
          padding: 10px
        }

        .skip-link {
          font-size: 15px;
          font-weight: normal;
          line-height: 1;

          a {
            color: white;
          }
        }

        &:first-child {
          margin-top: 0;
          text-align: left;
        }

        &:last-child {
          margin-bottom: 0;
        }
      }

      td {
        border-top: 1px solid ${globalStyleVariables.MEDIUM_BG};
        text-align: left;
        margin: 0;
        padding: 15px 30px; 
        line-height: 1.2;
        font-size: 16px;
        width:20%;

        @media (${globalStyleVariables.MOBILE_MEDIA_QUERY}) {
          padding: 10px
        }

        &:first-child {
          margin-top: 0;
          text-align: left;
        }

        &:last-child {
          margin-bottom: 0;
        }

        img {
          max-width: 100%;
        }
      }
    }
`

export const greenTick = (
  <img
    style={{ width: 14 }}
    src="https://ik.imagekit.io/ikmedia/website-2024/pricing-check.svg?updatedAt=1710133340631"
  ></img>
)

export const crossTick = (
  <img
    style={{ width: 12 }}
    src="https://ik.imgkit.net/ikmedia/website-assets/close-bold_q-haJPKmN.svg"
  ></img>
)

export const StyledButton = styled.button`
  background: #145fdd;
  background: ${props => (props.disabled ? "#8e9196" : "")};
  width: ${props => (props.width ? props.width : "auto")};
  white-space: nowrap;
  border: none;
  color: white;
  border-radius: ${globalStyleVariables.BUTTON_BORDER_RADIUS};
  height: 40px;
  font-size: 14px;
  font-weight: bold;
  padding: 10px 30px;
  cursor: pointer;
  outline: none;
  letter-spacing: 1px;
  @media (${globalStyleVariables.MOBILE_MEDIA_QUERY}) {
    margin-bottom: ${props => (props.title == "Login" ? "10px" : "")};
  }
  
  &.secondary {
    height: ${props => (props.height ? props.height : "auto")};
    background: #D4E6FC;
    color: #145fdd;
    font-weight: 600;
  }

  &.getStartedCTA {
    height: 50px;
    font-size: 14px;
    text-transform: uppercase;
    padding: 10px 40px;
  }

  &.getStartedReverse {
    height: 50px;
    font-size: 14px;
    text-transform: uppercase;
    padding: 10px 40px;
    background: ${globalStyleVariables.BLUE_OFF_WHITE};
    color: ${globalStyleVariables.BRAND_BLUE};

    &:hover {
      background: #f8f8f8;
    }
  }
`

const DesktopOnly = styled.div`
  @media (${globalStyleVariables.MOBILE_MEDIA_QUERY}) {
    display: none;
  }
`
export const DesktopOnlyBreak = styled.br`
  @media (${globalStyleVariables.MOBILE_MEDIA_QUERY}) {
    display: none;
  }

  display: block;
`

const MobileOnly = styled.div`
  @media (${globalStyleVariables.DESKTOP_MEDIA_QUERY}) {
    display: none;
  }
`

const Container = styled.div`
  flex-grow: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding: 0;
  width: 95vw;
  max-width: ${globalStyleVariables.CONTAINER_MAX_WIDTH};

  .margin-top-60 {
    margin-top: 60px;
  }

  @media (${globalStyleVariables.MOBILE_MEDIA_QUERY}) {
    padding: 0 20px;
    width: 100%;
  }
`
const HomePageContainer = styled.div`
  display: flex;
  flex-direction: row;
  max-width: ${globalStyleVariables.CONTAINER_MAX_WIDTH};
  width: 95vw;
  margin: 0 auto;

  .margin-top-60 {
    margin-top: 60px;
  }

  .graphic-container {
    display: flex;
    flex-direction: column;
    justify-content: center;

    img {
      margin-top: -112px;
      border-radius: 16px;
      @media (${globalStyleVariables.MOBILE_MEDIA_QUERY}) {
        margin-top: 50px;
        width: 100%;
      }
    }
    .mediaWithDotsShadowLeft {
      margin-top: -112px;
      margin-right: 8px;
      @media (${globalStyleVariables.MOBILE_MEDIA_QUERY}) {
        display: block;
        margin: 0 auto;
      }
    }
    .yellowDot {
      height: 200px;
      width: 200px;
      background: url("https://ik.imgkit.net/ikmedia/site_graphics/yellow_dot_space_1nxJi9lia.png");
      background-repeat: space;
      background-size: 24px;
      position: relative;
      left: -70px;
      margin-top: -112px;

      z-index: -1;

      @media (${globalStyleVariables.MOBILE_MEDIA_QUERY}) {
        display: none;
      }
    }
    .yellowDotRight {
      height: 200px;
      width: 200px;
      background: url("https://ik.imgkit.net/ikmedia/site_graphics/yellow_dot_space_1nxJi9lia.png");
      background-repeat: space;
      background-size: 24px;
      align-self: flex-end;
      position: relative;
      float: right;
      left: 70px;
      z-index: -1;

      @media (${globalStyleVariables.MOBILE_MEDIA_QUERY}) {
        display: none;
      }
    }
  }

  @media (${globalStyleVariables.MOBILE_MEDIA_QUERY}) {
    flex-direction: column;
    padding: 0 20px;
    width: 100vw;
  }
`

const Slab = styled.div`
  padding: ${props => (props.padding ? props.padding : globalStyleVariables.desktop.SLAB_TOP_BOTTOM_PADDING)} 0;
  background: ${props =>
    props.bg === "light" ? globalStyleVariables.LIGHT_BG : ""};
  background: ${props =>
    props.bg === "medium" ? globalStyleVariables.BLUE_OFF_WHITE : ""};
  background: ${props =>
    props.bg === "dark" ? globalStyleVariables.DARK_BG : ""};
  
  justify-content: center;
  align-items: center;
  display: flex;
  padding-top: ${props => (props.heroSection ? "70px" : "")};

  @media (${globalStyleVariables.MOBILE_MEDIA_QUERY}) {
    padding: ${props => (props.homePage ? 0 : globalStyleVariables.mobile.SLAB_TOP_BOTTOM_PADDING)} 0;
  }

  // if heroSection is set then set following
  ${props => (props.heroSection ? `.styled-content {
    margin-bottom: 32px;

    @media (${globalStyleVariables.MOBILE_MEDIA_QUERY}) {
      margin-bottom: 40px;
    }
  }` : "")};
`

export const GlossaryHeroSection = ({ title }) => {
  return (
    <Slab heroSection bg="medium">
      <Container>
        <MainTitle>{title}</MainTitle>
        <MainSubheading>
          <Link style={{ color: globalStyleVariables.LINK_COLOR }} to={"/glossary"}>
            <HStack>
              <FaChevronLeft />
              <Box>Glossary</Box>
            </HStack>
          </Link>
        </MainSubheading>
      </Container>
    </Slab>
  )
}

export const HeadingLabel = styled.h5`
  text-transform: uppercase;
  color: ${props => (props.color === "yellow" ? globalStyleVariables.BRAND_YELLOW : globalStyleVariables.BRAND_BLUE)}; ${globalStyleVariables.BRAND_BLUE};
  font-size: 20px;
  line-height: 12px;
  letter-spacing: 1.2px;
`

export const HeroSubTitle = styled.div`
  font-family: Poppins, sans-serif;
  font-size: 24px;
  font-weight: 500;
  line-height: 1.5;
  text-align: center;
  color: ${globalStyleVariables.TEXT_SECONDARY};
  margin-bottom: 14px;

  @media (${globalStyleVariables.MOBILE_MEDIA_QUERY}) {
    font-size: 16px;
  }
`

const MainTitle = styled.h1`
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  font-size: ${globalStyleVariables.desktop.H1_FONT_SIZE};
  text-align: ${props => (props.left ? "left" : "center")};
  width: ${props => (props.width ? props.width : "auto")};
  line-height: ${globalStyleVariables.desktop.H1_LINE_HEIGHT};
  color: ${globalStyleVariables.TEXT_PRIMARY};
  
  @media (${globalStyleVariables.MOBILE_MEDIA_QUERY}) {
    font-size: ${globalStyleVariables.mobile.H1_FONT_SIZE};
    line-height: ${globalStyleVariables.mobile.H1_LINE_HEIGHT};
  }
`

const Title = styled.h2`
  font-family: "Poppins", sans-serif;
  font-size: ${globalStyleVariables.desktop.H2_FONT_SIZE};
  font-weight: 600;
  text-align: ${props => (props.left ? "left" : "center")};
  line-height: ${globalStyleVariables.desktop.H2_LINE_HEIGHT};
  color: ${globalStyleVariables.TEXT_PRIMARY};
  margin-bottom: 32px;

  @media (${globalStyleVariables.MOBILE_MEDIA_QUERY}) {
    font-size: ${props => (props.homePage ? "24px" : globalStyleVariables.mobile.H2_FONT_SIZE)};
    margin-bottom: 16px;
  }
`

const MainSubheading = styled.h2`
  font-family: "Poppins", sans-serif;
  font-size: ${globalStyleVariables.desktop.H3_FONT_SIZE};
  font-weight: normal;
  text-align: ${props => (props.left ? "left" : "center")};
  line-height: ${globalStyleVariables.desktop.H3_LINE_HEIGHT};
  width: ${props => (props.width ? props.width : "auto")};
  max-width: 800px;
  margin: 24px 0 40px 0;
  text-rendering: optimizeLegibility;
  color: ${globalStyleVariables.TEXT_PRIMARY};

  @media (${globalStyleVariables.MOBILE_MEDIA_QUERY}) {
    width: auto;
    font-size: ${globalStyleVariables.mobile.H3_FONT_SIZE};
    line-height: ${globalStyleVariables.mobile.H3_LINE_HEIGHT};
    letter-spacing: ${globalStyleVariables.mobile.H3_LETTER_SPACING};
  }
`

const Subheading = styled.div`
  font-size: ${props => (props.fontSize ? "24px" : "18px")};
  font-weight: ${props => (props.fontWeight ? props.fontWeight : 400)};
  text-align: ${props => (props.left ? "left" : "center")};
  margin: ${props => (props.left ? "" : "0 auto")};
  margin-top: ${props => (props.margin ? "20px" : "0")};
  line-height: ${props => (props.lineHeight ? props.lineHeight : 1.56)};
  max-width: 700px;
  color: ${globalStyleVariables.BLUE_INACTIVE};
  text-rendering: optimizeLegibility;
  margin-bottom: 40px;

  a {
    text-decoration: none;
    color: ${globalStyleVariables.LINK_COLOR};
  }

  @media (${globalStyleVariables.MOBILE_MEDIA_QUERY}) {
    font-size: ${globalStyleVariables.mobile.H3_FONT_SIZE};
    margin-top: ${props => (props.margin ? "20px" : "0")};
    line-height: "normal"
  }
`
const HomePageSubheading = styled.p`
  font-size: 18px;
  font-weight: 400;
  text-align: ${props => (props.left ? "left" : "center")};
  margin: ${props => (props.left ? "" : "0 auto")};
  line-height: 1.56;
  max-width: 700px;
  color: ${globalStyleVariables.BLUE_INACTIVE};
  text-rendering: optimizeLegibility;
  letter-spacing: 0px;

  a {
    text-decoration: none;
    color: ${globalStyleVariables.LINK_COLOR};
  }

  @media (${globalStyleVariables.MOBILE_MEDIA_QUERY}) {
    font-size: ${globalStyleVariables.mobile.H3_FONT_SIZE};
    font-size: ${props => (props.homePage ? "24px" : globalStyleVariables.mobile.H2_FONT_SIZE)};
    font-weight: ${props => (props.homePage ? "normal" : "bold")};
    line-height: ${props => (props.homePage ? "32px" : "normal")};
    line-height: normal;
  }
`

const Content = styled.div.attrs({ className: "styled-content" })`
  display: flex;
  justify-content: center;
  gap: 24px;
  width: 100%;

  @media (${globalStyleVariables.MOBILE_MEDIA_QUERY}) {
    flex-direction: column;
    gap: 16px;
  }
`

const CTA = ({
  title = "Use For Free, Forever",
  link = "/registration",
  secondary = false,
  colorScheme = "imagekitBlue",
  size = "lg",
  fullWidth = false,
  usingInFrame = false
}) => {
  if (usingInFrame === true || link.includes("/registration")) {
    return (
      <Button
        as={"a"}
        href={link}
        target="_blank"
        colorScheme={colorScheme}
        variant={secondary ? "outline" : "solid"}
        size={size}
        {...(fullWidth ? { width: "full" } : {})}
        _focus={{
          outline: "none"
        }}
      >
        {title}
      </Button >
    )
  } else {
    return (
      <Button
        as={Link}
        to={link}
        colorScheme={colorScheme}
        variant={secondary ? "outline" : "solid"}
        size={size}
        {...(fullWidth ? { width: "full" } : {})}
        _focus={{
          outline: "none"
        }}
      >
        {title}
      </Button >
    )
  }
}

const InlineFormWrapper = styled.div`
  width: 100%;

  @media (${globalStyleVariables.DESKTOP_MEDIA_QUERY}) {
      max-width: 800px;
  }

  form {
    display: flex;
    padding: 5px;
    border-radius: 40px;
    background: white;
    border: 1px solid #dadada;

    input {
      border: none;
      padding-left: 15px;
      font-size: 14px;
      flex-grow: 1;
      height: 41px;
      vertical-align: middle;
      color: #333;
      outline: none;
      border-radius: 40px;
    }
  }

  .error-msg {
    font-size: 14px;
    padding: 10px 0;
    color: red;
  }
`

export const InlineInputField = ({
  initialValue = "",
  disabled = false,
  placeHolder = "Enter the value",
  CTALabel = "Submit",
  onSubmit,
  errorMsg,
  onInputChange,
}) => {
  const [inputValue, setInputValue] = useState(initialValue);

  const handleInputChange = (e) => {
    setInputValue(e.target.value); // Update the state with the new value
    if (onInputChange && typeof onInputChange === "function") {
      onInputChange(e.target.value);
    }
  };

  // Sync state with initialValue prop when it changes
  useEffect(() => {
    setInputValue(initialValue);
  }, [initialValue]);

  return (
    <form onSubmit={e => {
      e.preventDefault()
      if (onSubmit) {
        onSubmit(inputValue)
      }
    }}>
      <Flex
        direction={{ base: "column", md: "row" }}
        align={{ base: "stretch", md: "center" }}
        gap={4}
      >
        <Input
          placeholder={placeHolder}
          value={inputValue}
          w="100%"
          onChange={handleInputChange} />
        <Button size='md' variant="solid" borderRadius={"4px"} colorScheme="imagekitBlue" type="submit" disabled={disabled} isLoading={disabled}>{CTALabel}</Button>
      </Flex>
      {errorMsg &&
        <Box fontSize={"14px"} padding={"10px 0"} color={"red"}>
          {errorMsg}
        </Box>}
    </form>
  )
}

const MainBgPattern = () => (
  <div>
    <div
      style={{
        backgroundColor: globalStyleVariables.WHITE_PLACEHOLDER,
        height: "450px",
        width: "450px",
        borderRadius: "500px",
        position: "absolute",
        top: "200px",
        left: "-80px",
      }}
    ></div>
    <div
      style={{
        backgroundColor: globalStyleVariables.WHITE_PLACEHOLDER,
        height: "450px",
        width: "450px",
        borderRadius: "500px",
        position: "absolute",
        top: "-80px",
        right: "-80px",
      }}
    ></div>
  </div>
)

const BackgroundPattern = () => (
  <Pattern>
    <img
      style={{
        position: "absolute",
        top: 100,
        right: -250,
        zIndex: -1,
      }}
      src="https://ik.imgkit.net/ikmedia/website-assets/oval-bg_dnn8jSHS7h.svg"
    ></img>

    <img
      style={{
        position: "absolute",
        top: 417,
        left: -291,
        zIndex: -1,
      }}
      src="https://ik.imgkit.net/ikmedia/website-assets/oval-bg_dnn8jSHS7h.svg"
    ></img>
  </Pattern>
)

const TestiMonialWrapper = styled.div`
  width: 100%;
  display: grid;
  align-items: center;
  grid-template-columns: auto 80% auto;
  grid-template-rows: auto;
  grid-template-areas: "div1 div2 div3";
  

  @media (${globalStyleVariables.MOBILE_MEDIA_QUERY}) {
    grid-template-rows: auto auto;
    grid-template-columns: 50% 50%;
    grid-template-areas:
            "div2 div2"
            "div1 div3";
  }

  .button-prev {
    grid-area: div1;
    @media (${globalStyleVariables.MOBILE_MEDIA_QUERY}) {
      justify-self: right;
      padding-right: 10px;
    }
  }

  .content {
    grid-area: div2;
    
    @media (${globalStyleVariables.MOBILE_MEDIA_QUERY}) {
      width: calc(100vw - 42px);
      margin-bottom: 24px;
    }
  }

  .button-next {
    grid-area: div3;
    @media (${globalStyleVariables.MOBILE_MEDIA_QUERY}) {
      justify-self: left;
      padding-left: 10px;
    }
  }

  .swiper {
    width: 100%;
    height: 100%;
  }

  .swiper-slide {
    text-align: center;
    font-size: 18px;

    /* Center slide text vertically */
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .btn {
    cursor: pointer;
    user-select: none;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #718096;
    display: ${props => (props.count === 1 ? "none" : "flex")};

    :hover {
      color: initial;
    }

    @media (${globalStyleVariables.MOBILE_MEDIA_QUERY}) {
      display: none;
    }
  }

  .item {
    display: flex;
    width: 100%;
    flex-direction: column;
    padding: 40px;
    border-radius: 32px;
    border: solid 1px #ddd;
    background-color: #fff;

    @media (${globalStyleVariables.MOBILE_MEDIA_QUERY}) {
      flex-direction: column;
      padding: 24px;
    }

    .title {
      font-family: Poppins, sans-serif;
      font-size: 35px;
      font-weight: 600;
      line-height: 1.5;
      text-align: left;
      color: ${globalStyleVariables.TEXT_PRIMARY};
      margin-bottom: 16px;

      @media (${globalStyleVariables.MOBILE_MEDIA_QUERY}) {
        font-size: 20px;
        height: 60px
      }
    }

    .excerpt {
      font-family: Inter, sans-serif;
      font-size: 18px;
      line-height: 1.6;
      text-align: left;
      color: ${globalStyleVariables.TEXT_SECONDARY};
      margin-bottom: 32px;
      padding-bottom: 32px;
      border-bottom: solid 1px #ddd;
      white-space: normal;
      height: 120px;

      @media (${globalStyleVariables.MOBILE_MEDIA_QUERY}) {
        font-size: 14px;
        line-height: 1.8;
        margin-bottom: 25;
        padding-bottom: 25px;
        height: 250px;
      }
    }

    .customer {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 16px;
      font-family: Inter, sans-serif;
      white-space: nowrap;
      text-overflow: ellipsis;

      @media (${globalStyleVariables.MOBILE_MEDIA_QUERY}) {
        flex-direction: column;
        align-items: flex-start;
        font-size: 14px;
      }
    }

    .logo {
      max-width: 211px;
      height: 62px;
      display: flex;
      align-items: center;
      border-right: solid 1px #ddd;
      padding-right: 15px;
      margin-right: 15px;

      img {
        max-width: 100%;
        max-height: 100%;
      }

      @media (${globalStyleVariables.MOBILE_MEDIA_QUERY}) {
        border-right: none;
        margin-bottom: 16px;
        height: 40px;
      }
    }

    .author-name {
      font-weight: 600;
      line-height: 1.5;
      text-align: left;
      color: ${globalStyleVariables.TEXT_SECONDARY};
      margin-right: 8px;

      @media (${globalStyleVariables.MOBILE_MEDIA_QUERY}) {
        margin-right: 0;
      }
    }

    .author-title {
      line-height: 1.5;
      text-align: left;
      color: #718096;
    }

    .cta {
      margin-left: auto;

      @media (${globalStyleVariables.MOBILE_MEDIA_QUERY}) {
        margin-left: 0;
        margin-top: 16px;
      }

      a {
        font-family: Poppins, sans-serif;
        font-weight: 500;
        color: ${globalStyleVariables.LINK_COLOR};
        text-decoration: underline;
        text-underline-offset: 3px;
      }
    }
  }
`

export const TestimonialCarouselWithCaseStudies = ({ customerNames = [] }) => {
  const customerWithCaseStudyWithHighlights = [];
  const [showInMobile] = useMediaQuery(globalStyleVariables.MOBILE_MEDIA_QUERY_CHAKRA)

  customerList.map(item => {
    // If customerName is defined and item.name is not equal to customerName return
    if (customerNames && customerNames.length && !customerNames.includes(item.name)) {
      return;
    }
    if (item.caseStudy?.highlight && item.caseStudy?.hide !== true) {
      const { logo: customLogoUrl, name: customerName } = item;
      const { testimonials } = item;
      const { highlight } = item.caseStudy;

      if (testimonials?.length > 0) {
        // Push first testimonial
        const data = {
          highlight,
          testimonyText: testimonials[0].text,
          customLogoUrl,
          customerName,
          testimonyAuthor: testimonials[0].author,
          testimonyAuthorTitle: testimonials[0].authorTitle,
          caseStudyLink: item.caseStudy.link,
        };

        // If any property of data is not defined return
        Object.keys(data).forEach(key => {
          if (!data[key]) {
            return;
          }
        });

        customerWithCaseStudyWithHighlights.push(data);
      }
    }
  })

  return (
    <TestiMonialWrapper count={customerWithCaseStudyWithHighlights.length}>
      <div className="button-prev btn" >
        <MdArrowBack size={32} />
      </div>
      <div className="content">
        <Swiper
          navigation={{
            enabled: true,
            nextEl: '.button-next',
            prevEl: '.button-prev',
          }}
          loop={true}
          autoplay={{
            delay: 3500,
            disableOnInteraction: true,
          }}
          modules={[Navigation]}
          spaceBetween={showInMobile ? 8 : 50}
          slidesPerView={(showInMobile && customerWithCaseStudyWithHighlights.length > 1) ? 1.2 : 1}
          centeredSlides={showInMobile ? false : true}
        >
          {customerWithCaseStudyWithHighlights.map((item, i) => {
            const {
              highlight,
              testimonyText,
              customLogoUrl,
              customerName,
              testimonyAuthor,
              testimonyAuthorTitle,
              caseStudyLink,
            } = item
            return (
              <SwiperSlide props={{ key: { i } }}>
                <div className="item">
                  <div className="title">
                    <Text noOfLines={showInMobile ? 2 : 1}>{highlight}</Text>
                  </div>
                  <div className="excerpt">
                    <Text noOfLines={showInMobile ? 9 : 4}>{testimonyText}</Text>
                  </div>
                  <div className="customer">
                    <div className="logo">
                      <img src={customLogoUrl} alt={customerName} style={{ height: customLogoUrl.includes(".svg") ? "100%" : "" }} />
                    </div>
                    <div className="author-name">
                      {testimonyAuthor}
                    </div>
                    <div className="author-title">
                      ({testimonyAuthorTitle})
                    </div>
                    <div className="cta">
                      {caseStudyLink && <a target="_blank" href={caseStudyLink}>Read Case Study</a>}
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            )
          })}
        </Swiper>
      </div>

      <div className="button-next btn" >
        <MdArrowForward size={32} />
      </div>
    </TestiMonialWrapper>
  )
}

export const ImageCarousel = ({ imageUrls }) => {
  const [showInMobile] = useMediaQuery(globalStyleVariables.MOBILE_MEDIA_QUERY_CHAKRA)
  const navigationConfig = showInMobile ? {
    enabled: true,
  } : {
    enabled: true,
    nextEl: '.button-next',
    prevEl: '.button-prev',
  };
  return (
    <TestiMonialWrapper>
      <div className="button-prev btn" >
        <MdArrowBack size={32} />
      </div>
      <div style={{ width: "100%" }} className="content">
        <Swiper
          navigation={navigationConfig}
          modules={[Navigation]}
          loop={true}
          autoplay={{
            delay: 3500,
            disableOnInteraction: true,
          }}
        >
          {imageUrls.map((url, i) => {
            return (
              <SwiperSlide props={{ key: { i } }}>
                <div
                  style={{ maxWidth: 900, margin: "0 auto" }}
                  className="image-wrapper"
                >
                  <img style={{ maxWidth: "100%" }} src={url}></img>
                </div>
              </SwiperSlide>
            )
          })}
        </Swiper>
      </div>
      <div className="button-next btn" >
        <MdArrowForward size={32} />
      </div>
    </TestiMonialWrapper>
  )
}

const CaseStudyContainer = styled.div`
  display: grid;
  grid-template-columns: ${props => (props.count == 2 ? "repeat(2, 1fr)" : "repeat(3, 1fr)")};
  align-items: center;
  width: 100%;
  justify-content: space-around;
  align-items: stretch;
  gap: 40px;

  @media (${globalStyleVariables.MOBILE_MEDIA_QUERY}) {
    grid-template-columns: 1fr;
  }
`
const StyledCaseStudySmallVariant = styled.div`
  .cover-image {
    border-radius: 16px;
    padding: 16px;
    position: relative;
    display: flex;
    height: 225px;
    align-items: center;
    justify-content: center;

    .icon {
      height: 32px;
      width: 32px;
      position: absolute;
      top: 16px;
      right: 16px;
    }

    .customer-logo {
      height: 40px;
    }
  }

  .highlight {
    font-size: 20px;
    font-weight: 500;
    line-height: 1.4;
    margin-top: 24px;
    min-height: 56px;

    @media (${globalStyleVariables.MOBILE_MEDIA_QUERY}) {
      font-size: 16px;
      line-height: normal;
      min-height: initial;
    }
  }

  .cta {
    margin-top: 16px;
    margin-bottom: 20px;
    
    a {
      display: flex;
      align-items: center;
      text-decoration: underline;
      text-underline-offset: 3px;
      font-size: 16px;
      font-weight: 500;
      color: ${globalStyleVariables.LINK_COLOR};
    }
  }
`

const StyledCaseStudyBigVariant = styled.div`
  .container {
    border-radius: 16px;
    padding: 16px;

    .top-row {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;

      .customer-logo {
        height: 40px
      }
  
      .icon {
        height: 32px;
        width: 32px;
      }
    }

    .highlight {
      font-size: 20px;
      font-weight: 600;
      line-height: 1.4;
      color: white;
      margin-top: 250px;
      min-height: 56px;

      @media (${globalStyleVariables.MOBILE_MEDIA_QUERY}) {
        font-size: 16px;
        font-weight: 500;
        line-height: normal;
      }
    }

    .cta {
      color: white;
      font-size: 16px;
      font-weight: 500;
      line-height: 1.6;
      margin-top: 16px;

      @media (${globalStyleVariables.MOBILE_MEDIA_QUERY}) {
        font-size: 14px;
        line-height: 1.8;
      }

      a {
        display: flex;
        align-items: center;
        gap: 10px;
      }
    }
  }
`

const CaseStudySmallVariant = ({ customer }) => {
  const { name, logo, whiteLogo, caseStudy } = customer;
  const { coverImage, highlight, link, type = "text" } = caseStudy;
  const ctaTitle = type === "text" ? "Read Case Study" : "View Case Study";
  // Set icon url as doc or video icon based on type
  const iconUrl = type === "text" ? "https://ik.imagekit.io/ikmedia/Graphics/Website%20Revamp%20Graphics/Customers/icon-read.svg?updatedAt=1714112073388" : "https://ik.imagekit.io/ikmedia/Graphics/Website%20Revamp%20Graphics/Customers/icon-play.svg?updatedAt=1714112073448";
  return (
    <StyledCaseStudySmallVariant>
      <div className="cover-image"
        style={{
          backgroundImage: `url(${coverImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <img className="icon" src={iconUrl} />
        <img className="customer-logo" alt={name} src={whiteLogo ?? logo} />
      </div>
      <div className="highlight">
        {highlight}
      </div>
      <div className="cta">
        <a href={link} target="_blank" className="cta-button">
          {ctaTitle}
        </a>
      </div>
    </StyledCaseStudySmallVariant>
  )
}

const CaseStudyBigVariant = ({ customer }) => {
  const { name, logo, whiteLogo, caseStudy } = customer;
  const { coverImage, highlight, link, type = "text" } = caseStudy;
  const ctaTitle = type === "text" ? "Read Case Study" : "View Case Study";
  // Set icon url as doc or video icon based on type
  const iconUrl = type === "text" ? "https://ik.imagekit.io/ikmedia/Graphics/Website%20Revamp%20Graphics/Customers/icon-read.svg?updatedAt=1714112073388" : "https://ik.imagekit.io/ikmedia/Graphics/Website%20Revamp%20Graphics/Customers/icon-play.svg?updatedAt=1714112073448";
  return (
    <StyledCaseStudyBigVariant>
      <div className="container"
        style={{
          backgroundImage: `url(${coverImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}>

        <div className="top-row">
          <img className="customer-logo" alt={name} src={whiteLogo ?? logo} />
          <img className="icon" src={iconUrl} />
        </div>

        <div className="highlight">
          {highlight}
        </div>

        <div className="cta">
          <a href={link} target="_blank">
            {ctaTitle} <MdArrowForwardIos />
          </a>
        </div>
      </div>

    </StyledCaseStudyBigVariant>
  )
}

export const CaseSudies = ({
  customers = [],
  variant = "small",
}) => {
  const allCustomData = {};

  customerList.map((item) => {
    allCustomData[item.name] = item
  })

  const data = [];

  customers.map((customer) => {
    if (!allCustomData[customer]) {
      // If customer not found in customer list
      return null
      // throw new Error(`Customer ${customer} not found in customer list`)
    } else {
      data.push(allCustomData[customer])
    }
  })

  return (
    <CaseStudyContainer count={customers.length}>
      {data.map((customer, i) => {
        if (variant === "small") {
          return <CaseStudySmallVariant customer={customer} />
        } else {
          return <CaseStudyBigVariant customer={customer} />
        }
      })}
    </CaseStudyContainer>
  )
}

const LogoContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  max-width: 100vw;
  justify-content: space-around;
  gap: ${props => (props.condensed ? "15px" : "50px")};

  @media (${globalStyleVariables.MOBILE_MEDIA_QUERY}) {
    gap: 20px;
  }

  .item {
    img {
      max-width: 100%;
      max-height: 100%;
      &.gray-effect {
        filter: grayscale(1) opacity(0.7) brightness(0.8);
      }
    }

    &.lighten-logo {
      opacity: 0.825;
      &:hover {
        opacity: 1;
      }
    }
  }
`

export const CustomerLogos = ({
  customers = Object.values(MEDIA_PROCESSING_CUSTOMERS),
  count,
  grayEffect = false,
  marginBottom = 0,
  condensed = false,
  useWhiteLogo = false,
  marginTop = 32
}) => {
  var selectedCustomers = customerList.filter(
    item => item.logo && !item.hideLogo && customers.includes(item.name)
  )
  if (count) {
    selectedCustomers = selectedCustomers.slice(0, count)
  }

  return (
    <LogoContainer style={{ marginBottom, marginTop }} condensed={condensed}>
      {selectedCustomers.map((item, i) => {
        const { logo, whiteLogo, lightenLogo } = item
        const actualLogo = useWhiteLogo && whiteLogo ? whiteLogo : logo;
        const logoWidth = condensed ? 80 : 120;
        return (
          <div
            className={`item ${lightenLogo ? "lighten-logo" : ""}`}
            key={i}
          >
            <img
              className={`${grayEffect ? "gray-effect" : ""}`}
              src={`${actualLogo}?tr=w-120,dpr-2`}
              width={`${logoWidth}`}
            ></img>
          </div>
        )
      })}
    </LogoContainer>
  )
}

const InlineSectionCarourselWrapper = styled.div`
  .category-container {
    margin-top: 30px;
    //text-align: center;
    overflow: scroll;
    white-space: nowrap;
    scroll-snap-type: x mandatory;
    overscroll-behavior-x: contain;

    @media (${globalStyleVariables.MOBILE_MEDIA_QUERY}) {
      margin: 20px 0;
    }

    ::-webkit-scrollbar {
      width: 0px;
      height: 0px;
      background: transparent; /* Chrome/Safari/Webkit */
    }

    .item {
      font-size: 15px;
      padding: 12px 16px;
      display: inline-block;
      cursor: pointer;
      border-radius: 8px;
      scroll-snap-align: center;
      margin-right: 10px;
      background: ${globalStyleVariables.BLUE_OFF_WHITE};
      color: ${globalStyleVariables.TEXT_PRIMARY};

      &.active {
        background: ${globalStyleVariables.BRAND_LIGHT_BLUE};
        color: white;
        font-weight: 600;
      }
    }
  }
`

export const InlineSectionCaroursel = ({
  themeColor = globalStyleVariables.BRAND_BLUE,
  items = [],
  onSelect,
}) => {
  const [selectedIndex, setSelectedIndex] = useState(0)

  if (!items || !items.length) return <></>

  return (
    <InlineSectionCarourselWrapper themeColor={themeColor}>
      <div className="category-container">
        {items.map((item, i) => {
          return (
            <div
              key={i}
              className={`item ${selectedIndex === i ? "active" : ""}`}
              onClick={el => {
                el.target.scrollIntoView({
                  behavior: "smooth",
                  block: "nearest", // "start" | "center" | "end" | "nearest";
                  inline: "center", // "start" | "center" | "end" | "nearest";
                })
                setSelectedIndex(i)
                if (onSelect) onSelect(i)
              }}
            >
              {item}
            </div>
          )
        })}
      </div>
    </InlineSectionCarourselWrapper>
  )
}

export const MarkdownBody = ({ wideTable, children }) => {
  return (
    <MarkdownWrapper>
      <div className={`markdown-body ${wideTable ? "wide-table" : ""}`}>
        {children}
      </div>
    </MarkdownWrapper>
  )
}

export const ReviewScreenshots = ({ urls }) => {
  return (
    <div style={{ textAlign: "center" }}>
      {urls.map((url, i) => (
        <img
          key={i}
          src={url}
          style={{
            maxWidth: "1024px",
          }}
        ></img>
      ))}
    </div>
  )
}

const CompaniesDevelopersTitleWrapper = styled.div`
  font-family: Inter, sans-serif;
  font-size: 18px;
  line-height: 1.6;
  text-align: center;
  color: ${globalStyleVariables.TEXT_SECONDARY};
`

export const CompaniesDevelopersTitle = ({
  title = '',
  variation = ''
}) => {
  if (title) {
    return (
      <CompaniesDevelopersTitleWrapper>
        {title}
      </CompaniesDevelopersTitleWrapper>
    )
  } else {
    if (variation === "with_countries") {
      return (
        <CompaniesDevelopersTitleWrapper>
          Trusted by {DEVELOPER_COUNT} developers and {PAID_CUSTOMERS}+ high-growth businesses in {TOTAL_COUNTRIES} countries
        </CompaniesDevelopersTitleWrapper>
      )
    } else if (variation === "media_processing") {
      return (
        <CompaniesDevelopersTitleWrapper>
          {PAID_CUSTOMERS}+ companies process billions of media assets with ImageKit daily
        </CompaniesDevelopersTitleWrapper>
      )
    } else if (variation === "developers") {
      return (
        <CompaniesDevelopersTitleWrapper>
          {DEVELOPER_COUNT} developers and {PAID_CUSTOMERS}+ high-growth businesses trust ImageKit for their media processing needs
        </CompaniesDevelopersTitleWrapper>
      )
    } else {
      return (
        <CompaniesDevelopersTitleWrapper>
          {PAID_CUSTOMERS}+ companies process billions of media assets every day with ImageKit
        </CompaniesDevelopersTitleWrapper>
      )
    }
  }
}

export const CompaniesDevelopersTitleMediaAssets = ({
  showTitle = true,
  customersPage = false,
}) => {
  return (
    <CompaniesDevelopersTitleWrapper customersPage={customersPage}>
      {showTitle === true && (
        <div className="title">
          Over <span className="brandColor">{PAID_CUSTOMERS} businesses</span>{" "}
          and <span className="brandColor">{DEVELOPER_COUNT}+ users</span> trust
          ImageKit with their media assets on the web
        </div>
      )}
    </CompaniesDevelopersTitleWrapper>
  )
}

const G2RatingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 24px;

  @media (${globalStyleVariables.MOBILE_MEDIA_QUERY}) {
    flex-direction: column-reverse;
  }

  .g2-logo-container {
    display: flex;
    align-items: center;

    .g2-logo {
      height: 40px;
      margin-right: 16px;
    }
  }

  .rating-number {
    font-family: Inter, sans-serif;
    font-weight: bold;
    font-size: 14px;
    line-height: 21px;
    color: ${props => (props.theme === "light" ? globalStyleVariables.TEXT_PRIMARY : "white")};
  }

  .badges {
    display: flex;
    gap: 16px;
    align-items: center;

    img {
      width: 90px;

      @media (${globalStyleVariables.MOBILE_MEDIA_QUERY}) {
        width: 60px;
      }
    }
  }
`

export const RatingBadge = ({ theme = "light" }) => {
  const rating = 4.6;
  return (
    <Link to="https://www.g2.com/products/imagekit/reviews" target="_blank" rel="noopener noreferrer">
      <G2RatingContainer theme={theme}>
        <div className="g2-logo-container">
          <img className="g2-logo" src="https://ik.imagekit.io/ikmedia/website-2024/g2/reversed-g2@2x.png?updatedAt=1714196459754" />
          <div className="rating">
            <Rating rating={rating}></Rating>
            <DesktopOnly><div className="rating-number">{rating}/5</div></DesktopOnly>
          </div>
        </div>
        <div className="badges">
          <img src="https://ik.imagekit.io/ikmedia/website-2024/g2/Leader1.svg?updatedAt=17141960700226" />
          {/* <img src="https://ik.imagekit.io/ikmedia/website-2024/g2/Leader2.svg?updatedAt=1714196070334" /> */}
          <img src="https://ik.imagekit.io/ikmedia/website-2024/g2/MostImplementable.svg?updatedAt=17141960270252" />
          <img src="https://ik.imagekit.io/ikmedia/website-2024/g2/BestUsability.svg?updatedAt=17141960702393" />
        </div>
      </G2RatingContainer>
    </Link>
  )
}

const StyledDAMLPRatingBadge = styled.div`
  display: flex;
  max-width: 800px;
  align-items: center;
  justify-content: space-between;
  margin: 0 auto;
  gap: 40px;

  @media (${globalStyleVariables.MOBILE_MEDIA_QUERY}) {
    display: none;
  }

  .text {
    display: flex;
    align-items: center;

    .item {
      border-right: 1px solid ${globalStyleVariables.BLACK_DIVIDER};
      font-size: 18px;
      text-align: center;
      padding: 0 20px;

      &:last-child {
        border-right: none;
      }

      .heading {
        font-size: 48px;
        font-weight: 500;
        margin-bottom: 20px;
        color: ${globalStyleVariables.BLACK_ACTIVE};
      } 

      .sub-heading {
        color: ${globalStyleVariables.BLACK_INACTIVE};
      }
    }
  }

  .g2-logo {
    img {
      width: 240px;
      max-width: 100%;
      max-height: 100%;
    }
  }
`

export const DAMLPRatingBadge = () => {
  return (
    <DesktopOnly>
      <Slab>
        <Container>
          <StyledDAMLPRatingBadge>
            <div className="text">
              <div className="item">
                <div className="heading">93%</div>
                <div className="sub-heading">Users rate us as the easiest DAM to use</div>
              </div>
              <div className="item">
                <div className="heading">6</div>
                <div className="sub-heading">Months or less to ROI</div>
              </div>
              <div className="item">
                <div className="heading">4.6</div>
                <div className="sub-heading">Rated high on G2 DAM grid</div>
              </div>
            </div>
            <div className="g2-logo">
              <img src="https://ik.imagekit.io/ikmedia/g2-leader-winter-25.png"></img>
            </div>
          </StyledDAMLPRatingBadge>
        </Container>
      </Slab>
    </DesktopOnly>
  )
}

export const Rating = ({ rating }) => {
  var items = [];
  for (var i = 1; i <= 5; i++) {
    if (rating >= i) {
      items.push(<FaStar style={{ width: 16, color: "#ffc700" }} key={i} />);
    } else if (rating >= i - 0.5) {
      items.push(<FaStarHalfAlt style={{ width: 16, color: "#ffc700" }} key={i} />);
    }
  }

  return <div style={{ display: "flex" }}>{items}</div>;
}

const TOCWrapper = styled.div`
  font-family: -apple-system,"system-ui","Segoe UI",Roboto,"Helvetica Neue",Ubuntu;
  @media (max-width: 1370px) {
    width: 200px;
  }

  @media (${globalStyleVariables.MOBILE_MEDIA_QUERY}) {
    display: none;
  }

  position: fixed;
  top: 60px;
  visibility: hidden;
  opacity: 0;
  transition-duration: 0.2s;
  left: 60px;
  width: 250px;
  max-height: calc(100vh - 100px);
  overflow: auto;

  .title {
    font-weight: bold;
    font-size: 14px;
    color: ${globalStyleVariables.BLUE_INACTIVE};
    text-transform: uppercase;
  }

  ul {
    list-style: none;
    li {
      margin: 10px 0;
      font-size: 15px;
      a {
        color: initial;
        text-decoration: none;

        &.highlighted {
          color: ${globalStyleVariables.LINK_COLOR};
        }
      }
    }
  }

  &.visible {
    visibility: visible;
    opacity: 1;
  }
`

const RightSideFloatingWrapper = styled.div`
  font-family: -apple-system,"system-ui","Segoe UI",Roboto,"Helvetica Neue",Ubuntu;

  @media (${globalStyleVariables.MOBILE_MEDIA_QUERY}) {
    display: none;
  }

  position: fixed;
  top: 60px;
  visibility: hidden;
  opacity: 0;
  transition-duration: 0.2s;
  right: 60px;
  width: 200px;

  &.visible {
    visibility: visible;
    opacity: 1;
  }
`

export const RightSideFloating = ({ children }) => {
  var visibility = {
    "hero-section": false,
    content: false,
    "content-end": false,
    "hide-toc": false
  }
  const [showing, setShowing] = useState(false)
  useEffect(() => {
    var threshold = []
    for (let i = 0; i <= 1.0; i += 0.01) {
      threshold.push(i)
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries = entries.reverse()
        entries.forEach(entry => {
          const id = entry.target.id != "" ? entry.target.id : entry.target.className
          visibility[id] = entry.isIntersecting
        })
        if (
          !visibility["hero-section"] &&
          visibility["content"] &&
          !visibility["content-end"] &&
          !visibility["hide-toc"]
        ) {
          setShowing(true)
        } else {
          setShowing(false)
        }
      },
      {
        root: null,
        threshold: threshold,
      }
    )

    observer.observe(document.getElementById("hero-section"))
    observer.observe(document.getElementById("content"))
    observer.observe(document.getElementById("content-end"))
    document.querySelectorAll(".hide-toc").forEach(node => {
      observer.observe(node)
    })
  }, [])

  return (
    <RightSideFloatingWrapper className={`${showing ? "visible" : ""}`}>
      {children}
    </RightSideFloatingWrapper>
  )
}

export const TOC = ({ items }) => {
  var visibility = {
    "hero-section": false,
    content: false,
    "content-end": false,
    "hide-toc": false
  }
  const [showing, setShowing] = useState(false)
  const [activeSection, setActiveSection] = useState("")
  useEffect(() => {
    var threshold = []
    for (let i = 0; i <= 1.0; i += 0.01) {
      threshold.push(i)
    }
    var observer = new IntersectionObserver(
      function (entries) {
        // Revere the entries so that first top item is the active one
        entries = entries.reverse()
        entries.forEach(entry => {
          const id = entry.target.id != "" ? entry.target.id : entry.target.className
          visibility[id] = entry.isIntersecting
          var title = entry.target.getAttribute("data-title")
          if (title) {
            if (entry.isIntersecting) {
              setActiveSection(slugger.slug(title))
            }
          }
        })
        if (
          !visibility["hero-section"] &&
          visibility["content"] &&
          !visibility["content-end"] &&
          !visibility["hide-toc"]
        ) {
          setShowing(true)
        } else {
          setShowing(false)
        }
      },
      {
        root: null,
        threshold: threshold,
      }
    )

    observer.observe(document.getElementById("hero-section"))
    observer.observe(document.getElementById("content"))
    observer.observe(document.getElementById("content-end"))
    document.querySelectorAll(".hide-toc").forEach(node => {
      observer.observe(node)
    })
    document.querySelectorAll("section[data-title]").forEach(node => {
      observer.observe(node)
    })
  }, [])

  return (
    <TOCWrapper className={`${showing ? "visible" : ""}`}>
      <div className="title">Table of Contents</div>
      <ul>
        {items.map((item, index) => {
          return (
            <li key={index}>
              <a
                href={`#${slugger.slug(item.title)}`}
                onClick={event => {
                  scrollIntoView(event)
                }}
                className={`${activeSection === slugger.slug(item.title)
                  ? "highlighted"
                  : ""
                  }`}
              >
                {item.label}
              </a>
            </li>
          )
        })}
      </ul>
    </TOCWrapper>
  )
}

export const scrollIntoView = event => {
  if (event.currentTarget) {
    var href = event.currentTarget.getAttribute("href")
    if (href && document.getElementById(href.slice(1))) {
      document.getElementById(href.slice(1)).scrollIntoView()
    }
  }
}

const DividerWrapper = styled.div`
  hr {
    border: 1px solid
      ${props =>
    props.type == "black"
      ? globalStyleVariables.BLACK_DIVIDER
      : globalStyleVariables.WHITE_DIVIDER};
  }
`

export const Divider = props => {
  return (
    <DividerWrapper type={props.type || "black"}>
      <hr style={{ border: "0.5px solid #617597" }}></hr>
    </DividerWrapper>
  )
}

const BandAid = styled.div`
  width: ${props => props.width};
  height: ${props => props.height};
  position: relative;
  top: ${props => props.top};
  background-color: ${props =>
    props.backgroundColor
      ? props.backgroundColor
      : globalStyleVariables.BLUE_OFF_WHITE};
  border-radius: 300px;
  -webkit-transform: rotate(-45deg);
  -ms-transform: rotate(-45deg);
  transform: rotate(-45deg);
  z-index: -1;
  margin-left: ${props => (props.marginLeft ? props.marginLeft : "auto")};;
  margin-right: auto;
  margin-top: ${props => (props.marginTop ? props.marginTop : "0px")};
`

const BadgeSpan = styled.span`
  background-color: #e9d8fd;
  color: #44337a;
  text-transform: uppercase;
  vertical-align: middle;
  font-weight: bold;
  border-radius: 4px;
  padding: 2px 6px;
  font-size: 12px;
  margin-top: 0px;
  margin-inline: 0.5rem 0px;
  margin-bottom: 0px;
`;
export const Badge = ({
  title = "Badge"
}) => {
  return (
    <BadgeSpan>
      {title.toLocaleLowerCase()}
    </BadgeSpan>
  )
}

export const BackgroundEllipseDesign = styled.div`
	width: 500px;
	height: 500px;
	position: absolute;
	left: ${props => props.left};
    top: ${props => props.top};
    z-index: -1;
	background-color: ${globalStyleVariables.BLUE_OFF_WHITE};
	border-radius: 300px;
`

export const TransformationString = styled.span`
  background: ${props => props.homePage ? "#D2E7FD" : globalStyleVariables.BRAND_RED_PLACEHOLDER};
  color: ${props => props.homePage ? globalStyleVariables.BRAND_LIGHT_BLUE : globalStyleVariables.BRAND_RED};
  border-radius: ${props => props.homePage ? "5px" : "3px"};
  padding: 3px;
  display: inline;

  @media (${globalStyleVariables.MOBILE_MEDIA_QUERY}) {
    font-size: ${props => props.homePage ? "14px" : "initial"};
  }
`;
export const HomePageTransformationString = styled.div`
  background: ${globalStyleVariables.BRAND_RED_PLACEHOLDER};
  color: ${globalStyleVariables.BRAND_RED};
  border-radius: 5px;
  padding: 5px;

  @media (${globalStyleVariables.MOBILE_MEDIA_QUERY}) {
    font-size: initial;
  }
`;
const LoginDivider = styled.hr`
  overflow: visible;
  padding: 0;
  border: none;
  border-top: 1px solid #e0e0e0;
  color: #6e6d7a;
  text-align: center;
  margin: 0px 15px;
  margin-top: 20px;
  &:after {
    content: "Or";
    display: inline-block;
    position: relative;
    top: -11px;
    font: normal 14px/14px "Haas Grot Text R Web", "Helvetica Neue", Helvetica,
      Arial, sans-serif;
    padding: 0 16px;
    background: #fff;
  }
`

export const SDK = () => {
  return (
    <Slab>
      <Container>
        <Title>
          Developer-first SDKs & plugins
        </Title>
        <Subheading as="p" width={"800px"}>
          Built with DevEx at our core—clear APIs, rock-solid SDKs, crystal-clean <a href="https://imagekit.io/docs" target="_blank">docs</a>, and dev-to-dev support, so you can ship faster with confidence.
        </Subheading>
        <Content style={{ marginBottom: 0 }}>
          <Wrap spacing={3} maxW={"800px"} justify={"center"}>
            {sdkList.map((sdk, index) => (
              <WrapItem key={index}>
                <a href={sdk.link} target="_blank" style={{ textDecoration: 'none' }}>
                  <Button
                    style={{ textTransform: "none", transition: "transform 0.2s ease" }}
                    variant="sdk"
                    size="md"
                    leftIcon={<Icon as={sdk.icon} boxSize={5} color="gray.700" />}
                    _hover={{ transform: "scale(1.05)", backgroundColor: "imagekitBlue.300" }}
                  >
                    {sdk.name}
                  </Button>
                </a>
              </WrapItem>
            ))}
          </Wrap>
        </Content>
      </Container>
    </Slab>
  )
}

export const GuideLastUpdateDate = ({ publishDate }) => {
  // if publishDate is not specified or invalid return null
  const date = moment(publishDate, "DD MMM YYYY");
  if (!date.isValid()) {
    return null;
  }

  let dateStr = date.format("D MMM YYYY");

  // If date is before 13th of last month, then return 13th of last month
  const lastMonthDate = moment().subtract(1, "months").startOf("month").add(13, "days");
  if (date.isBefore(lastMonthDate)) {
    dateStr = lastMonthDate.format("D MMM YYYY");
  }

  return (
    <p><strong>Last updated</strong> - {dateStr}</p>
  )
}

const ImageOptimizationChecklistWrapper = styled.div`
  margin-bottom: 20px;
  border: solid 1px #CCC;
  border-radius: 4px;
  padding: 15px 30px;
  display: flex;
  align-items: flex-start;

  .checkbox {
    margin-right: 20px;
    margin-top: 3px;
  }

  .title {
    font-weight: bold;
    cursor: pointer;

    label {
      cursor: pointer;
    }
  }

  .description {
    margin-top: 10px;
    font-size: 16px;
  }
`

const ChecklistItemImportanceBadge = ({ importance }) => {
  // If high importance, show a green badge otherwise purple
  if (importance === "High") {
    return (
      <ChakraBadge marginLeft={"20px"} lineHeight={2} colorScheme='green' >High Importance</ChakraBadge>
    )
  } else if (importance === "Medium") {
    return (
      <ChakraBadge marginLeft={"20px"} lineHeight={2} colorScheme='purple' >Medium Importance</ChakraBadge>
    )
  } else if (importance === "Low") {
    return (
      <ChakraBadge marginLeft={"20px"} lineHeight={2} >Low Importance</ChakraBadge>
    )
  } else {
    return null
  }
}

export const ImageOptimizationChecklist = () => {
  const defaultValue = [
    {
      "title": "Compress images",
      "difficulty": "Medium",
      "importance": "High",
      "description": <>
        Choosing the correct compression settings allows for a balance between image quality and file size, which speeds up image loading without compromising visual clarity. <a href="#chapter-5---compress-images">Learn how to compress images</a>.
      </>,
      completed: false
    },
    {
      "title": "Adopt WebP/AVIF",
      "difficulty": "Medium",
      "importance": "High",
      "description": <>
        Modern image formats like WebP or AVIF can significantly reduce file size while maintaining high-quality visuals, leading to faster loading times.
        <br />Learn <a href="#chapter-6---optimizing-image-format">how to deliver an image in the best possible format</a>.
      </>,
      completed: false
    },
    {
      "title": "Correctly resize images on server-side",
      "difficulty": "Medium",
      "importance": "High",
      "description": <>
        Serving images at the correct dimensions reduces unnecessary data overhead, enhancing speed and efficiency in image delivery.
        <br /><a href="#chapter-7---resizing-images-to-fit-the-layout">Resizing images on server-side</a> • <a href="#how-to-resize-images-on-the-fly">On the fly resizing</a>
      </>,
      completed: false
    },
    {
      "title": "Utilize a CDN",
      "difficulty": "Medium",
      "importance": "High",
      "description": <>
        A <a href="#chapter-9---using-cdn-for-fast-download">Content Delivery Network (CDN)</a> enhances image delivery by serving them from a server closest to the user. This proximity significantly reduces load times and improves response rates, optimizing the user experience across different global locations.
      </>,
      completed: false
    },
    {
      "title": "Implement responsive images",
      "difficulty": "High",
      "importance": "Medium",
      "description": <>
        Ensure that your application <a href="#how-to-load-the-correct-image-in-your-application">loads the right image</a>. Consider implementing responsive images using srcset and size attributes.
      </>,
      completed: false
    },
    {
      "title": "Replace GIFs with video",
      "difficulty": "Medium",
      "importance": "Medium",
      "description": <>
        Replacing <a href="#how-to-convert-gif-to-video-or-animated-webp">GIFs with videos</a> or animated WebP reduces file size and load times while saving bandwidth costs.
      </>,
      completed: false
    },
    {
      "title": "Set image dimensions",
      "difficulty": "Low",
      "importance": "Medium",
      "description": "Specifying width and height on images prevents layout shifts during loading, improving user experience and Cumulative Layout Shift scores.",
      completed: false
    },
    {
      "title": "Use SVGs for icons",
      "difficulty": "Low",
      "importance": "Medium",
      "description": "Vector images like SVGs are ideal for logos and icons as they scale without losing quality, are smaller in file size, and render sharply on all screen resolutions.",
      completed: false
    },
    {
      "title": "Implement lazy loading",
      "difficulty": "Low",
      "importance": "Medium",
      "description": <>
        Lazy loading defers loading of images until they are in or near the viewport, reducing initial load time and saving bandwidth costs. <a href="#chapter-8---lazy-loading-images">Learn more.</a>
      </>,
      completed: false
    },
    {
      "title": "Use preconnect and priority hints",
      "difficulty": "Low",
      "importance": "Low",
      "description": <>
        Preconnect hints enable the browser to establish early connections to domains hosting images, which accelerates image loading when accessed by users. Additionally, using <a href="https://web.dev/articles/fetch-priority" target="_blank">priority hint</a> to prioritize images at the top of the page can enhance the Largest Contentful Paint (LCP), significantly improving the perceived load speed of the page.
      </>,
      completed: false
    },
    {
      "title": "Monitor relevant Core Web Vitals",
      "difficulty": "Medium",
      "importance": "High",
      "description": <>
        Tracking relevant <a href="#chapter-3---core-web-vitals-for-image-performance">Core Web Vitals</a> helps identify areas for improvement, ensuring optimal user experience and SEO rankings.
      </>,
      completed: false
    }
  ];

  // Initialize state with default value.
  const [tasks, setTasks] = useState(defaultValue);

  useEffect(() => {
    // Ensure this code runs only on the client side
    if (typeof window !== "undefined") {
      const savedTasks = localStorage.getItem('taskCompletionStatus');
      const savedTasksStatus = savedTasks ? JSON.parse(savedTasks) : {};

      // Update tasks state based on localStorage data or default
      setTasks(tasks => tasks.map(task => ({
        ...task,
        completed: !!savedTasksStatus[task.title]
      })));
    }
  }, []);

  // Use useEffect to update local storage whenever tasks state changes
  useEffect(() => {
    const taskCompletionStatus = tasks.reduce((acc, task) => {
      acc[task.title] = task.completed;
      return acc;
    }, {});
    localStorage.setItem('taskCompletionStatus', JSON.stringify(taskCompletionStatus));
  }, [tasks]);

  // Function to toggle the completion status of a task
  const toggleCompletion = (title) => {
    const updatedTasks = tasks.map(task => {
      if (task.title === title) {
        return { ...task, completed: !task.completed };
      }
      return task;
    });
    setTasks(updatedTasks);
  };

  return (
    <>
      {tasks.map((task, index) => (
        <ImageOptimizationChecklistWrapper key={index}>
          <div className="checkbox">
            <Checkbox
              id={`checkbox-${index}`}
              isChecked={task.completed}
              size='lg'
              onChange={() => toggleCompletion(task.title)}
            />
          </div>
          <div className="content">
            <div className="title">
              <label htmlFor={`checkbox-${index}`}>
                <h3>
                  {task.title}
                  <ChecklistItemImportanceBadge importance={task.importance} />
                </h3>
              </label>
            </div>
            {task.description &&
              <div className="description">
                {task.description}
              </div>
            }
          </div>
        </ImageOptimizationChecklistWrapper>
      ))}
    </>
  )
}

export const LossyImageCompressionExample = () => {
  // Create a grid of images along with file sizes and compression settings
  const qualityLevels = [
    {
      url: "https://ik.imagekit.io/ikmedia/example_image.jpg?tr=f-jpg,q-100",
      quality: 100,
      size: "1.2 MB",
    },
    {
      url: "https://ik.imagekit.io/ikmedia/example_image.jpg?tr=f-jpg,q-80",
      quality: 80,
      size: "162KB",
    },
    {
      url: "https://ik.imagekit.io/ikmedia/example_image.jpg?tr=f-jpg,q-60",
      quality: 60,
      size: "93KB",
    }
  ];

  return (
    <div>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "20px", fontSize: 14, textAlign: "center" }}>
        {qualityLevels.map(({ url, quality, size }) => (
          <div key={quality}>
            <img src={url} alt={`Image with quality ${quality}`} style={{ width: "100%" }} />
            <p>Quality: {quality}, File Size: {size}
              <br></br><a href={url} target="_blank">Open Image</a>
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}

export const ImageOptimizationExample = () => {
  // Create a grid of images along with file sizes and compression settings
  const qualityLevels = [
    {
      url: "https://ik.imagekit.io/ikmedia/example_image.jpg?tr=orig-true",
      label: "Original image - 1.2MB",
      format: "JPG",
      quality: "Original",
      size: "1.2 MB",
    },
    {
      url: "https://ik.imagekit.io/ikmedia/example_image.jpg?tr=f-webp,q-80",
      label: "Webp at 80 compression - 72 KB",
      format: "WebP",
      quality: 80,
      size: "72KB",
    },
    {
      url: "https://ik.imagekit.io/ikmedia/example_image.jpg?tr=f-avif,q-80",
      label: "AVIF at 80 compression -  43 KB",
      format: "AVIF",
      quality: 80,
      size: "43KB",
    }
  ];

  return (
    <div>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "20px", fontSize: 14, textAlign: "center" }}>
        {qualityLevels.map(({ url, format, label, size }, index) => (
          <div key={index}>
            <img src={url} alt={`${format} image`} style={{ width: "100%" }} />
            <p>{label}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export {
  BackgroundPattern, BandAid, Container, Content, CTA, DesktopOnly, HomePageContainer, LoginDivider, MainBgPattern, MainSubheading, MainTitle, MobileOnly, Slab, Subheading, Title
}

const TestimonialContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 32px;

  @media (${globalStyleVariables.MOBILE_MEDIA_QUERY}) {
    display: block;
    white-space: nowrap;
    overflow: auto;
    padding-bottom: 20px;
  }

  .item {
    padding: 24px;
    border-radius: 16px;
    border: solid 1px #ddd;
    background-color: #fff;
    display: flex;
    flex-direction: column;

    @media (${globalStyleVariables.MOBILE_MEDIA_QUERY}) {
        width: 80%;
        max-width: 380px;
        margin-right: 8px;
        display: inline-flex;
    }
  }

  .text {
    font-size: 16px;
    line-height: 1.8;
    text-align: left;
    margin: 24px 0;
    color: ${globalStyleVariables.TEXT_SECONDARY};
    white-space: normal;
  }

  .author {
    display: flex;
    align-items: center;
    gap: 16px;

    .pic {
        height: 24px;
        width: 24px;
        border-radius: 100%;
        overflow: hidden;
    }

    .name {
        font-family: Poppins, sans-serif;
        font-size: 16px;
        font-weight: 500;
        line-height: 1.5;
    }
  }
`

export const DAMTestimonials = ({ hardCodedTestimonials }) => {
  const [showInMobile] = useMediaQuery(globalStyleVariables.MOBILE_MEDIA_QUERY_CHAKRA)
  return (
    <TestimonialContainer>
      {hardCodedTestimonials.map(({ rating, text, authorPicUrl, authorName }) => {
        return (
          <div className="item">
            <div className="rating">
              <Rating rating={rating}></Rating>
            </div>
            <div className="text">
              <Text noOfLines={showInMobile ? 7 : 4}>{text}</Text>
            </div>
            <div className="author">
              <div className="pic">
                <img src={authorPicUrl}></img>
              </div>
              <div className="name">
                {authorName}
              </div>
            </div>
          </div>
        )
      })}
    </TestimonialContainer>
  )
}

export const StorylaneEmbed = ({ url }) => {
  return (
    <div style={{ width: "100%", maxWidth: "1064px" }}>
      <Script src="https://js.storylane.io/js/v1/storylane.js" />
      <div className="sl-embed" style={{
        position: 'relative',
        paddingBottom: 'calc(56.46% + 27px)',
        width: '100%',
        height: '0',
        transform: 'scale(1)',
      }
      }>
        <iframe className="sl-demo" src={url} name="sl-embed" allow="fullscreen; camera; microphone" style={{
          position: 'absolute',
          top: '0',
          left: '0',
          width: '100%',
          height: '100%',
          border: '1px solid rgba(63, 95, 172, 0.35)',
          boxShadow: '0px 0px 18px rgba(26, 19, 72, 0.15)',
          borderRadius: '10px',
          boxSizing: 'border-box',
        }
        }></iframe>
      </div>
    </div>
  )
}

const FAQSection = styled.div`
  width: 100%;

  a {
    color: ${globalStyleVariables.BRAND_BLUE};
  }

  .category-container {
    display: flex;
    flex-wrap: wrap;
    margin: 38px 0 70px 0;
    justify-content: center;
    gap: 16px;

    @media (${globalStyleVariables.MOBILE_MEDIA_QUERY}) {
      margin: 24px 0 40px 0;
    }

    .item {
      padding: 8px 24px;
      border-radius: 16px;
      font-family: Inter, sans-serif;
      font-size: 18px;
      font-weight: 500;
      line-height: 1.5;
      text-align: center;
      color: ${globalStyleVariables.BRAND_BLUE};
      display: inline-block;
      cursor: pointer;

      &:hover {
        background-color: #d9e7ffab;
      }

      &.active {
        background-color: ${globalStyleVariables.BRAND_BLUE} !important;
        color: ${globalStyleVariables.WHITE_ACTIVE};
      }
    }
  }

  .faqs {
    max-width: 900px;
    margin: 0 auto;

    .question {
      font-size: 18px;
      line-height: 1.6;
      text-align: left;
      color: ${globalStyleVariables.TEXT_PRIMARY};
      font-family: Inter, sans-serif;
      padding: 8px 0;
    }

    .answer {
      font-size: 16px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.38;
      letter-spacing: normal;
      text-align: left;
      // color: ${globalStyleVariables.TEXT_SECONDARY};

      p {
        margin-top: 15px;
      }
    }
  }
`

export const FAQs = ({ faqItems, faqCategories, answerMargin = "16px 0 0" }) => {
  const [faqCategory, setFaqCategory] = useState(faqCategories?.[0]?.category ?? "")
  return (
    <FAQSection>
      {faqCategory &&
        <div className="category-container">
          {faqCategories.map((item, i) => {
            return (
              <div
                key={i}
                className={`item ${faqCategory === item.category ? "active" : ""
                  }`}
                onClick={() => {
                  setFaqCategory(item.category)
                }}
              >
                {item.label}
              </div>
            )
          })}
        </div>
      }
      <div className="faqs">
        <Accordion allowToggle allowMultiple>
          {faqItems
            .filter(item => {
              if (!faqCategory) return true
              else return item.category === faqCategory
            })
            .map((faq, i) => {
              return (
                <AccordionItem>
                  <h2 style={{ margin: 0, padding: 0, position: "inherit" }}>
                    <AccordionButton>
                      <Box as="span" flex='1' textAlign='left'>
                        <div className="question"><b>{faq.question}</b></div>
                      </Box>
                      <AccordionIcon />
                    </AccordionButton>
                  </h2>
                  <AccordionPanel pb={4}>
                    <div className="answer" style={{ margin: answerMargin }}>{faq.answer}</div>
                  </AccordionPanel>
                </AccordionItem>
              )
            })}
        </Accordion>
      </div>
    </FAQSection>
  )
}

// Function to play video
export const playVideo = async (ref) => {
  try {
    if (ref.current && ref.current.paused) {
      await ref.current.play();
    }
  } catch (ex) { }
};

// Function to pause video
export const pauseVideo = (ref) => {
  try {
    if (ref.current) {
      ref.current.pause();
    }
  } catch (ex) { }
};

const ExternalProviderIntegrationWrapper = styled.div`
  margin-top: 32px;
  display: flex;
  justify-content: center;
  gap: 90px;
  align-items: center;

  @media (${globalStyleVariables.MOBILE_MEDIA_QUERY}) {
    gap: 15px;
    flex-wrap: wrap;
  }

  img {
    max-height: 50px;

    @media (${globalStyleVariables.MOBILE_MEDIA_QUERY}) {
      max-height: 40px;
    }
  }
`

export const ExternalProviderIntegration = () => {
  const providers = {
    "AWS": "https://ik.imagekit.io/ikmedia/website-2024/2x/aws.png?updatedAt=1709549668679",
    "GC": "https://ik.imagekit.io/ikmedia/website-2024/2x/google-cloud.png?updatedAt=1709549668627",
    "Akeneo": "https://ik.imagekit.io/ikmedia/website-2024/2x/akeneo.png?updatedAt=1709631414166",
    "DO": "https://ik.imagekit.io/ikmedia/website-2024/2x/digitalocean-logo-vector.svg?updatedAt=1714194269675",
    "Cloudinary": "https://ik.imagekit.io/ikmedia/website-2024/2x/cld.png?updatedAt=1709631414100",
    "Azure": "https://ik.imagekit.io/ikmedia/website-2024/2x/azure.png?updatedAt=1709549668631",
    "GoogleDrive": "https://ik.imagekit.io/ikmedia/website-2024/2x/google-drive.png?updatedAt=1709549668599"
  }
  return (
    <>
      <Title>
        Works with your existing storage
      </Title>
      <Box style={{ textAlign: 'center', fontSize: 18, maxWidth: 1050, lineHeight: 1.6 }}>
        ImageKit Media Processing API works with all popular cloud storage and HTTP servers. Whether you store assets across multiple locations or migrate cloud storage in the future, ImageKit ensures real-time optimized delivery, transformations, and streaming for your images and videos.
      </Box>
      <ExternalProviderIntegrationWrapper>
        {Object.values(providers).map((logo) => {
          return (
            <a href="https://docs.imagekit.io/integration/configure-origin" target="_blank">
              <div>
                <img src={logo}></img>
              </div>
            </a>
          )
        })}
      </ExternalProviderIntegrationWrapper>
    </>
  )
}


const ProductSideBySideWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 35px;
  flex-direction: row;

  @media (${globalStyleVariables.MOBILE_MEDIA_QUERY}) {
    flex-direction: column;
  }

  .item {
    display: flex;
    flex-direction: column;
    padding: 32px 32px 0 32px;
    border-radius: 32px;
    border: solid 1px #e1e4eb;
    background-color: rgba(214, 224, 255, 0.5);
    align-items: center;

    &#dam-product {
      background-color: rgba(199, 247, 255, 0.5);
    }

    @media (${globalStyleVariables.MOBILE_MEDIA_QUERY}) {
      width: auto;
      height: auto;
    }
  }

  .label {
    flex-grow: 0;
    font-family: Poppins, sans-serif;
    font-size: 16px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    text-align: center;
    color: #0450d5;
    margin-bottom: 16px;
  }

  .title {
    align-self: stretch;
    flex-grow: 0;
    font-family: Poppins, sans-serif;
    font-size: 24px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    text-align: center;
    margin-bottom: 8px;

    @media (${globalStyleVariables.MOBILE_MEDIA_QUERY}) {
      font-size: 20px;
    }
  }

  .description {
    align-self: stretch;
    flex-grow: 0;
    font-family: Inter, sans-serif;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    text-align: center;
    color: ${globalStyleVariables.TEXT_SECONDARY};
    margin-bottom: 16px;

    @media (${globalStyleVariables.MOBILE_MEDIA_QUERY}) {
      font-size: 14px;
    }
  }

  .inline-video {
    margin-top: 90px;
    border-top-left-radius: 32px;
    border-top-right-radius: 32px;
    // border: solid 1px #ddd;
    // border-bottom: none;

    @media (${globalStyleVariables.MOBILE_MEDIA_QUERY}) {
      margin-top: 37px;
    }
  }
`

export const ProductSideBySide = ({ }) => {
  const video1Ref = React.useRef(null);
  const video2Ref = React.useRef(null);
  return (
    <ProductSideBySideWrapper>
      <div className="item" id="media-processing-product" onMouseOver={() => playVideo(video1Ref)} onMouseOut={() => pauseVideo(video1Ref)}>
        {/* <div className="label">For Tech Teams</div> */}
        <h3 className="title">Image and Video API</h3>
        <div className="description">50+ real-time optimizations, transformations, and streaming capabilities via a URL-based image and video processing API.</div>
        <CTA
          secondary={true}
          height={"50px"}
          width={"156px"}
          title="Learn More"
          link="/products/media-processing"
          isExternal={true}
        ></CTA>
        <video ref={video1Ref} poster={"https://ik.imagekit.io/ikmedia/Graphics/2024%20Website%20Graphics/Homepage/For%20Technology%20Teams.mp4/ik-thumbnail.jpg?updatedAt=1714051112382671&tr=w-1290,h-824"} preload="none" className="inline-video" src="https://ik.imagekit.io/ikmedia/Graphics/2024%20Website%20Graphics/Homepage/For%20Technology%20Teams.mp4?updatedAt=1714051112382671&tr=w-1290,h-824" loop muted />
      </div>
      <div className="item" id="dam-product" onMouseOver={() => playVideo(video2Ref)} onMouseOut={() => pauseVideo(video2Ref)}>
        {/* <div className="label">For Marketing & Creative Teams</div> */}
        <h3 className="title">Digital Asset Management</h3>
        <div className="description">A central hub to efficiently manage, search, and collaborate on all digital assets with internal and external stakeholders.</div>
        <CTA
          secondary={true}
          height={"50px"}
          width={"156px"}
          title="Learn More"
          link="/products/digital-asset-management"
          isExternal={true}
        ></CTA>
        <video ref={video2Ref} poster={"https://ik.imagekit.io/ikmedia/Graphics/2024%20Website%20Graphics/Homepage/Marketing%20&%20Creative%20Teams.mp4/ik-thumbnail.jpg?updatedAt=1714052311127736&tr=w-1290,h-824"} preload="none" className="inline-video" src="https://ik.imagekit.io/ikmedia/Graphics/2024%20Website%20Graphics/Homepage/Marketing%20&%20Creative%20Teams.mp4?updatedAt=1714052311127736&tr=w-1290,h-824" loop muted />
      </div>
    </ProductSideBySideWrapper>
  )
}

export const ProductCardWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 35px;
  flex-direction: row;
  margin-top: 24px;

  @media (${globalStyleVariables.MOBILE_MEDIA_QUERY}) {
    flex-direction: column;
  }

  .item {
    display: flex;
    flex-direction: column;
    padding: 32px 32px 0 32px;
    border-radius: 32px;
    border: solid 1px #e1e4eb;
    background-color: rgba(214, 224, 255, 0.5);
    align-items: center;
    flex: 1;

    &.dam {
      background-color: rgba(199, 247, 255, 0.5);
    }

    &.white-bg {
        background-color: #FFFFFF;
    }

    @media (${globalStyleVariables.MOBILE_MEDIA_QUERY}) {
      width: auto;
      height: auto;
    }
  }

  .title {
    align-self: stretch;
    flex-grow: 0;
    font-family: Poppins, sans-serif;
    font-size: 24px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    text-align: left;
    margin-bottom: 35px;
    height: 72px;

    @media (${globalStyleVariables.MOBILE_MEDIA_QUERY}) {
      font-size: 20px;
    }
  }

  .description {
    align-self: stretch;
    flex-grow: 0;
    font-family: Inter, sans-serif;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    text-align: left;
    color: ${globalStyleVariables.TEXT_SECONDARY};
    margin-bottom: 35px;

    @media (${globalStyleVariables.MOBILE_MEDIA_QUERY}) {
      font-size: 14px;
    }
  }

  .inline-video {
    margin-top: auto;
    border-top-left-radius: 32px;
    border-top-right-radius: 32px;

    @media (${globalStyleVariables.MOBILE_MEDIA_QUERY}) {
      margin-top: 37px;
    }
  }
`

export const ProgramFeatures = styled.div`
display: grid;
grid-template-columns: 2fr 2fr;
gap: 56px;

@media (${globalStyleVariables.MOBILE_MEDIA_QUERY}) {
  grid-template-columns: 1fr;
  gap: 32px;
}

.item {
  display: grid;
  grid-template-columns: 25px 1fr;
  gap: 8px;
  max-width: 480px;

  .icon {
    img {
      width: 100%;
    }
  }

  .heading {
    font-family: Poppins, sans-serif;
    font-size: 20px;
    font-weight: 500;
    line-height: 1.5;
    margin-bottom: 8px;

    @media (${globalStyleVariables.MOBILE_MEDIA_QUERY}) {
      font-size: 16px;
      line-height: normal;
    }
  }

  .text {
    font-family: Inter, sans-serif;
    font-size: 16px;
    font-style: normal;
    line-height: 1.5;
    text-align: left;

    @media (${globalStyleVariables.MOBILE_MEDIA_QUERY}) {
      font-size: 14px;
    }
  }
}
`